const DECIMAL_REGEX =
    /^-?(?:90(?:\.0+)?|[1-8]?\d(?:\.\d+)?),\s*-?(?:180(?:\.0+)?|1[0-7]\d(?:\.\d+)?|[1-9]?\d(?:\.\d+)?)$/

const DMS_REGEX =
    /^\s*(\d{1,2})°\s*(\d{1,2})'\s*(\d{1,2}(?:\.\d+)?)"?([NS])\s+(\d{1,3})°\s*(\d{1,2})'\s*(\d{1,2}(?:\.\d+)?)"?([EW])\s*$/i

const DDM_REGEX =
    /^\s*(-?\d+)\s+(\d+(?:\.\d+)?)\s*,\s*(-?\d+)\s+(\d+(?:\.\d+)?)\s*$/

export const isGpsLocation = (value = "") => DECIMAL_REGEX.test(value.trim())
export const isDMSLocation = (value = "") => DMS_REGEX.test(value.trim())
export const isDDMLocation = (value = "") => DDM_REGEX.test(value.trim())

export function transformDMSToDecimal(dmsString) {
    const dmsMatch = dmsString.trim().match(DMS_REGEX)
    if (!dmsMatch) {
        return null
    }

    const latDegrees = parseFloat(dmsMatch[1])
    const latMinutes = parseFloat(dmsMatch[2])
    const latSeconds = parseFloat(dmsMatch[3])
    const latDirection = dmsMatch[4].toUpperCase()

    const lonDegrees = parseFloat(dmsMatch[5])
    const lonMinutes = parseFloat(dmsMatch[6])
    const lonSeconds = parseFloat(dmsMatch[7])
    const lonDirection = dmsMatch[8].toUpperCase()

    let latitude = latDegrees + (latMinutes / 60) + (latSeconds / 3600)
    let longitude = lonDegrees + (lonMinutes / 60) + (lonSeconds / 3600)

    if (latDirection === "S") {
        latitude = -latitude
    }
    if (lonDirection === "W") {
        longitude = -longitude
    }

    return [latitude, longitude]
}

export function transformDDMToDecimal(ddmString) {
    const match = ddmString.trim().match(DDM_REGEX)
    if (!match) {
        return null
    }

    const latDeg = parseInt(match[1], 10)
    const latMin = parseFloat(match[2])
    const lonDeg = parseInt(match[3], 10)
    const lonMin = parseFloat(match[4])

    let lat = Math.abs(latDeg) + latMin / 60
    if (latDeg < 0) {
        lat *= -1
    }

    const lon = Math.abs(lonDeg) + lonMin / 60
    const lng = lonDeg < 0 || ddmString.includes("-0") ? -lon : lon

    return [lat, lng]
}